module.exports = __webpack_public_path__ + "img/schema_otn_1a.29eea04d.svg";